import type { GetServerSideProps } from 'next'

import { NewestPage } from '@features/newest/pages/NewestPage'
import { AppLayout } from '@components/layouts/AppLayout'
import { OgShare } from '@components/OgShare'
import { BASE_URL } from '@configs/config'
import { BookEnum } from '@interfaces/BookEnum'
import { maintenanceHandler } from '@lib/maintenanceHandler'
import { AppLinkMeta } from '@components/AppLinkMeta'

function Newest({ url, bookType }: { url: string; bookType: BookEnum | null }) {
  const bookTypeParam = bookType ? `?bookType=${bookType}` : ''

  return (
    <AppLayout>
      <AppLinkMeta path={`newest${bookTypeParam}`} webUrl={url} />
      <OgShare url={url} />
      <NewestPage bookType={bookType || undefined} />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  query,
}) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
    bookType: query.bookType || null,
  })
}

export default Newest
